module.exports = __webpack_public_path__ + "static/media/leandro-v.282fc1e8.png";